import { Row, Select, Spin } from "antd";
import React, { useEffect, useState } from "react";
import API from "../services/api-request";

const SelectWarehouse = ({ value, onChange }) => {
  const [listData, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  const getWarehouse = async () => {
    setLoading(true);
    API.Get(`warehouse`)
      .then((res) => {
        const newData = res?.data;
        const filteredData = newData.filter(
          (item) =>
            !listData.find((existingItem) => existingItem.id === item.id)
        );
        setData((prevData) => [...prevData, ...filteredData]);
      })
      .catch((err) => console.log(err))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    getWarehouse();
  }, []);

  return (
    <Select
      style={{ width: "100%" }}
      allowClear
      showSearch
      value={value || null}
      optionFilterProp="label"
      placeholder="Select Warehouse"
      onChange={onChange}
      notFoundContent={
        loading ? (
          <Row justify={"center"}>
            <Spin size="small" className="center" />
          </Row>
        ) : (
          "No Data"
        )
      }
      options={listData?.map((e) => ({
        label: e.name,
        value: e.id,
      }))}
    />
  );
};

export default SelectWarehouse;
